import React from 'react';
import styled from 'styled-components';
import {
	TwitterShareButton,
	FacebookShareButton,
	LinkedinShareButton,
	PinterestShareButton
} from 'react-share';

const StyledSocialShare = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	max-width: 580px;
	margin: auto;
	margin-bottom: 70px;

	@media screen and (max-width: 767px) {
		flex-direction: column;
		gap: 15px;
		margin-bottom: 50px;
	}

	button {
		outline: 0 !important;
		margin: 4px 8px;
		transition: transform 0.3s ease-in-out;
		border: none;
		width: 38px;
		height: 38px;
		border-radius: 30px;
		text-align: center;
		padding: 9px !important;
		background: #9e9e9e !important;
		display: inline-flex;
		align-items: center;
		justify-content: center;

		&:hover {
			svg {
				transform: scale(1.1);
			}
		}
	}
`;

const SocialShare = () => {
	return (
		<StyledSocialShare>
			<div>Share on social media</div>
			<div className='icons-wrapper'>
				<TwitterShareButton url={window.location.href}>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='16'
						height='16'
						viewBox='0 0 16 16'
						fill='none'
					>
						<g clipPath='url(#clip0_273_834)'>
							<path
								d='M13.7204 5.06776C14.306 4.65196 14.7986 4.13296 15.2 3.53536V3.53476C14.6642 3.76936 14.0942 3.92536 13.4991 4.00096C14.111 3.63556 14.5784 3.06136 14.798 2.36956C14.2274 2.70976 13.5974 2.94976 12.926 3.08416C12.3842 2.50696 11.612 2.14996 10.7696 2.14996C9.13525 2.14996 7.81945 3.47656 7.81945 5.10256C7.81945 5.33656 7.83925 5.56156 7.88785 5.77576C5.43385 5.65576 3.26185 4.47976 1.80265 2.68756C1.54825 3.12976 1.39825 3.63556 1.39825 4.17976C1.39825 5.20216 1.92445 6.10816 2.70985 6.63316C2.23525 6.62416 1.77025 6.48616 1.37605 6.26956V6.30196C1.37605 7.73656 2.39905 8.92816 3.74125 9.20296C3.50065 9.26896 3.23905 9.30016 2.96725 9.30016C2.77825 9.30016 2.58745 9.28936 2.40865 9.24976C2.79085 10.4186 3.87685 11.2784 5.16685 11.3066C4.16245 12.092 2.88685 12.5654 1.50625 12.5654C1.26445 12.5654 1.03225 12.5546 0.800049 12.5252C2.10805 13.3682 3.65725 13.85 5.32885 13.85C10.5386 13.85 13.934 9.50356 13.7204 5.06776Z'
								fill='white'
							/>
						</g>
						<defs>
							<clipPath id='clip0_273_834'>
								<rect
									width='14.4'
									height='14.4'
									fill='white'
									transform='translate(0.800049 0.799988)'
								/>
							</clipPath>
						</defs>
					</svg>
				</TwitterShareButton>
				<FacebookShareButton url={window.location.href}>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='16'
						height='16'
						viewBox='0 0 16 16'
						fill='none'
					>
						<g clipPath='url(#clip0_273_136)'>
							<path
								d='M10.3982 3.19099H11.7128V0.901388C11.486 0.870188 10.706 0.799988 9.79761 0.799988C7.90221 0.799988 6.60381 1.99219 6.60381 4.18339V6.19999H4.51221V8.75959H6.60381V15.2H9.16821V8.76019H11.1752L11.4938 6.20059H9.16761V4.43719C9.16821 3.69739 9.36741 3.19099 10.3982 3.19099Z'
								fill='white'
							/>
						</g>
						<defs>
							<clipPath id='clip0_273_136'>
								<rect
									width='14.4'
									height='14.4'
									fill='white'
									transform='translate(0.800049 0.799988)'
								/>
							</clipPath>
						</defs>
					</svg>
				</FacebookShareButton>
				<LinkedinShareButton url={window.location.href}>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='16'
						height='16'
						viewBox='0 0 16 16'
						fill='none'
					>
						<g clipPath='url(#clip0_273_2087)'>
							<path
								d='M15.1964 15.2V15.1994H15.2V9.91816C15.2 7.33456 14.6438 5.34436 11.6234 5.34436C10.1714 5.34436 9.19703 6.14116 8.79923 6.89656H8.75723V5.58556H5.89343V15.1994H8.87543V10.439C8.87543 9.18556 9.11303 7.97356 10.6652 7.97356C12.1946 7.97356 12.2174 9.40396 12.2174 10.5194V15.2H15.1964Z'
								fill='white'
							/>
							<path
								d='M1.0376 5.58618H4.0232V15.2H1.0376V5.58618Z'
								fill='white'
							/>
							<path
								d='M2.52925 0.799988C1.57465 0.799988 0.800049 1.57459 0.800049 2.52919C0.800049 3.48379 1.57465 4.27459 2.52925 4.27459C3.48385 4.27459 4.25845 3.48379 4.25845 2.52919C4.25785 1.57459 3.48325 0.799988 2.52925 0.799988V0.799988Z'
								fill='white'
							/>
						</g>
						<defs>
							<clipPath id='clip0_273_2087'>
								<rect
									width='14.4'
									height='14.4'
									fill='white'
									transform='translate(0.800049 0.799988)'
								/>
							</clipPath>
						</defs>
					</svg>
				</LinkedinShareButton>
				<PinterestShareButton url={window.location.href}>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='16'
						height='16'
						viewBox='0 0 16 16'
						fill='none'
					>
						<g clipPath='url(#clip0_273_2347)'>
							<path
								d='M8.19563 0.799988C4.24822 0.800588 2.15002 3.32959 2.15002 6.08719C2.15002 7.36579 2.86462 8.96119 4.00882 9.46699C4.33522 9.61399 4.29202 9.43459 4.57282 8.36059C4.59502 8.27119 4.58362 8.19379 4.51162 8.11039C2.87602 6.21859 4.19242 2.32939 7.96223 2.32939C13.418 2.32939 12.3986 9.87859 8.91143 9.87859C8.01263 9.87859 7.34303 9.17299 7.55483 8.29999C7.81163 7.26019 8.31443 6.14239 8.31443 5.39299C8.31443 3.50419 5.50042 3.78439 5.50042 6.28699C5.50042 7.06039 5.77402 7.58239 5.77402 7.58239C5.77402 7.58239 4.86862 11.24 4.70062 11.9234C4.41622 13.0802 4.73902 14.9528 4.76722 15.1142C4.78462 15.203 4.88422 15.2312 4.94002 15.158C5.02942 15.041 6.12382 13.4798 6.43042 12.3512C6.54203 11.9402 6.99983 10.2722 6.99983 10.2722C7.30163 10.817 8.17163 11.273 9.09863 11.273C11.8562 11.273 13.8494 8.84899 13.8494 5.84119C13.8398 2.95759 11.372 0.799988 8.19563 0.799988V0.799988Z'
								fill='white'
							/>
						</g>
						<defs>
							<clipPath id='clip0_273_2347'>
								<rect
									width='14.4'
									height='14.4'
									fill='white'
									transform='translate(0.800049 0.799988)'
								/>
							</clipPath>
						</defs>
					</svg>
				</PinterestShareButton>
			</div>
		</StyledSocialShare>
	);
};

export default SocialShare;
